import { compose } from 'recompose';

import Receipt from './Receipt';

import apiInterceptor from '../../../api/interceptor';

import { paymentApi,salesInvoiceApi } from '../../common/base.api';

const composedReceipt = compose(apiInterceptor({ ...paymentApi,agentDataList:salesInvoiceApi?.getAgentList, }))(Receipt);

export default composedReceipt;
